import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/_app/projects/$projectId/jobs/create')({
    beforeLoad: ({params}) => {
        throw redirect({
            to: '/projects/$projectId/jobs/add',
            params: {projectId: params.projectId},
            replace: true,
        })
    },
})
